import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

const SEVERITY_COLOR = {
  low: '#5764F5',
  medium: '#FFD88C',
  high: '#FF771D',
  critical: '#C0383D',
};

const ThreatGeoChip = ({ countryCode, severity, text }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Box sx={{ height: 12, width: 12, borderRadius: 6, bgcolor: SEVERITY_COLOR[severity] }} />
    <Typography
      sx={{ fontSize: 16, color: '#FFF', textTransform: 'capitalize' }}
      data-testid={`threat_geo-${countryCode ?? ''}-${severity}`}
    >
      {text}
    </Typography>
  </Stack>
);

ThreatGeoChip.propTypes = {
  severity: PropTypes.string,
  countryCode: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ThreatGeoChip;
